// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

import { Button } from "antd";
import { CloseOutlined, PushpinOutlined } from "@ant-design/icons";
import type { RoomEvent } from "../types";

function bodyOf(ev: RoomEvent): string {
  if (ev.type === "m.room.encrypted") {
    const c = ev.decryptedContent as { body?: string } | undefined;
    return c ? String(c.body ?? "") : "🔒 encrypted message";
  }
  return String((ev.content as { body?: string }).body ?? "");
}

// PinnedBar is the strip above the timeline showing a channel's pinned messages.
export function PinnedBar({
  events,
  canPin,
  onUnpin,
  displayFor,
}: {
  readonly events: RoomEvent[];
  readonly canPin: boolean;
  readonly onUnpin: (eventID: string) => void;
  readonly displayFor: (userID: string) => string;
}) {
  if (events.length === 0) return null;
  return (
    <div className="pinned-bar">
      {events.map((ev) => (
        <div className="pinned-item" key={ev.event_id}>
          <PushpinOutlined className="pinned-icon" />
          <span className="pinned-who">{displayFor(ev.sender)}:</span>
          <span className="pinned-text">{bodyOf(ev)}</span>
          {canPin && (
            <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => onUnpin(ev.event_id)} title="Unpin" />
          )}
        </div>
      ))}
    </div>
  );
}
